import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import LoginPage from "./pages/LoginPage";
import HomePage from "./pages/HomePage";
import TicketListPage from "./pages/TicketListPage";
import TicketCreatePage from "./pages/TicketCreatePage";
import TicketDetailPage from "./pages/TicketDetailPage";
import KnowledgeBasePage from "./pages/KnowledgeBasePage";
import HashtagBrowserPage from "./pages/HashtagBrowserPage";
import DashboardPage from "./pages/DashboardPage";
import SettingsPage from "./pages/SettingsPage";
import UserManagementPage from "./pages/UserManagementPage";
import SupportControlCenter from "./pages/SupportControlCenter";
import { Toaster } from "sonner";

function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center" style={{ background: '#0F0F1A' }}><div className="w-8 h-8 rounded-full animate-pulse" style={{ background: '#F77F00' }} /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
      <Route path="/" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
      <Route path="/tickets" element={<ProtectedRoute><TicketListPage /></ProtectedRoute>} />
      <Route path="/tickets/all" element={<ProtectedRoute><TicketListPage allTickets /></ProtectedRoute>} />
      <Route path="/tickets/new" element={<ProtectedRoute><TicketCreatePage /></ProtectedRoute>} />
      <Route path="/tickets/:ticketId" element={<ProtectedRoute><TicketDetailPage /></ProtectedRoute>} />
      <Route path="/knowledge-base" element={<ProtectedRoute><KnowledgeBasePage /></ProtectedRoute>} />
      <Route path="/hashtags" element={<ProtectedRoute><HashtagBrowserPage /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute roles={['direction', 'support', 'dn']}><DashboardPage /></ProtectedRoute>} />
      <Route path="/admin/users" element={<ProtectedRoute roles={['direction']}><UserManagementPage /></ProtectedRoute>} />
      <Route path="/support-control" element={<ProtectedRoute roles={['support']}><SupportControlCenter /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <LanguageProvider>
          <AppRoutes />
          <Toaster position="top-right" theme="dark" toastOptions={{ style: { background: '#1A1A2E', border: '1px solid rgba(247,127,0,0.3)', color: '#fff' } }} />
        </LanguageProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
